import { httpsCallable } from "firebase/functions";
import { db, auth, firestore, functions } from "../../firebase";
import { collection, doc, getDoc, getDocs, limit, onSnapshot, orderBy, query, setDoc, where } from "firebase/firestore";
import { NotificationProps } from "common/models/User";


  export const CheckUserLogin = (navigate:any)=>{
    const UserLogin = auth.currentUser;
    if (UserLogin==null) {    
        navigate("/");
      }
  }
  
  export const getMyPurchasedProducts = async (userId: string) => {
    try {
      const getMyPurchasedProductsFunction = httpsCallable(functions, 'getMyPurchasedProducts');
     
      const result = await getMyPurchasedProductsFunction({ userId });
      // const result = await getMyPurchasedProductsFunction({ userId:"0085nojGvUblbQ4LXOeU0H9Mb4Q2" });
     
      return result.data;
    } catch (error) {
      console.error('Error calling getMyPurchasedProducts:', error);
      throw error;
    }
  };

  export const getAllNotifications = async (userId: any, setNotifications:any, limitNumber:number) => {    
    const q = query(
        collection(db, 'notifications'),
        where('user', '==', userId || ''),
        orderBy('time', 'desc'),
        limit(limitNumber)
    );
    
    const unsubscribe = onSnapshot(q, (querySnapshot:any) => {
        const data:any = [];
        // setNotificationCount((prev:any) => prev + 1)
        querySnapshot.forEach((doc:any) => {
            data.push({ notificationId:doc?.id, ...doc.data() });
        });        
        setNotifications(data as NotificationProps);   
    });    
    return unsubscribe;
};

export const cardTradNotificationsCount = async (userId: any, setNotificationCount: any, limitNumber:number) => {    
  const q = query(
      collection(db, 'notifications'),
      where('user', '==', userId || ''),
      where('notificationSeen', '==', false),
      // orderBy('time', 'desc'),
      limit(limitNumber)
  );
  
  const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const data:any = [];
      querySnapshot.forEach((doc) => {
          data.push({ ...doc.data() });
      });        
      setNotificationCount(data?.length)
      // setNotifications(data as NotificationProps);   
  });    
  return unsubscribe;
};

export const telegramLoginData = async (queryString:any) => {
  let params = new URLSearchParams(queryString);

  // Decode and parse 'user' parameter
  let userEncoded = params.get('user');
  // @ts-ignore
  let userDecoded = JSON.parse(decodeURIComponent(userEncoded));

  // Extract other needed parameters
  let authDate = params.get('auth_date');
  let hash = params.get('hash');

  // Construct the object
  let result = {
      id: userDecoded.id,
      first_name: userDecoded.first_name,
      secret: process.env.REACT_APP_TELEGRAM_LOGIN_SECRET_KEY,
      auth_date: Number(authDate),
      hash: hash,
  };
  return result
};